import { AssertMustContainUniqueArrayElementsException } from './assert-must-contain-unique-array-elements.exception';

export function assertMustContainUniqueArrayElements<T>(
  value: unknown,
  message: string,
): asserts value is T[] {
  if (Array.isArray(value) && new Set(value).size !== value.length) {
    throw new AssertMustContainUniqueArrayElementsException(
      `Must contain unique array elements: ${message}`,
    );
  }
}
